import type { ProductVoucher } from '@/domainLogic/types/typesProduct.ts';
import { VOUCHER_TYPE } from '@/domainLogic/types/typesProduct.ts';
import type { Page } from '@/app/common/starTrack/events/utils/starTrack.types.ts';

export const VOUCHER_INFO_CODE_COPIED = 'VOUCHER_INFO_CODE_COPIED';
export const VOUCHER_INFO_CODE_COPIED_VERSION = '1.1';

export type VoucherInfoCodeCopiedPayload = {
  searchId: string;
  page: Page;
  productDetailKey?: string;
  voucherCode: string;
  voucherAmount: number;
  voucherCurrency: string;
  voucherType: string;
};

export type VoucherInfoCodeCopiedParams = {
  searchId: string;
  voucher: ProductVoucher;
};

export const createVoucherInfoCodeCopiedPayload = ({
  searchId,
  voucher,
}: VoucherInfoCodeCopiedParams): VoucherInfoCodeCopiedPayload => ({
  searchId,
  page: 'RESULT_PAGE', // TODO: to be implemented when the event will be triggered in 'DETAILS_PAGE'
  productDetailKey: undefined, // TODO: to be implemented when the event will be triggered in 'DETAILS_PAGE'
  voucherCode: voucher.code,
  voucherAmount: voucher.discountValue,
  voucherCurrency: voucher.discountCurrency,
  voucherType: voucher.discountType === VOUCHER_TYPE.PERCENTAGE ? 'PERC' : 'AMOUNT',
});
